export function locationValidate(location){
    var result = true;

    result = validateId(location.id);
    result = validateName(location.name);
    result = validateIsAvailable(location.is_available);
    result = validateWarehouseId(location.warehouse_id);
    result = validateBarcode(location.barcode);
    result = validateStackingLevel(location.stacking_level);
    result = validateLType(location.l_type);
    result = validateIsEnabled(location.is_enabled);
    result = validateBayId(location.bay_id);

    return result;
}

function validateId(id) {    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name) {
    if( typeof name == "string") return true;
    else return false;
} 

function validateIsAvailable(is_available) {
    if( typeof is_available == "boolean") return true;
    else return false;
} 

function validateWarehouseId(warehouse_id) {    
    if(Number.isInteger(warehouse_id)) return true;
    else return false;
}

function validateBarcode(barcode) {
    if( typeof barcode == "string") return true;
    else return false;
}

function validateStackingLevel(stacking_level) {
    if(Number.isInteger(stacking_level)) return true;
    else return false;
}

function validateLType(l_type) {
    if( typeof l_type == "string") return true;
    else return false;
}

function validateIsEnabled(is_enabled) {
    if( typeof is_enabled == "boolean") return true;
    else return false;   
}

function validateBayId(bay_id) {
    if(Number.isInteger(bay_id)) return true;
    else return false;
}